var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgArrowUpNavigation = function SvgArrowUpNavigation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.44 26.56L25.5 8.62V46h-3V8.62L4.56 26.56l-2.12-2.12L24 2.88l21.56 21.56-2.12 2.12z"
  })));
};

export default __webpack_public_path__ + "static/media/arrow-up-navigation.7cef08c9.svg";
export { SvgArrowUpNavigation as ReactComponent };